import React from 'react';
import { Boton } from '../Boton'; 

export function Tarjeta({ titulo, descripcion, onAceptar, onCancelar }) {
  return (
    <div className="tarjeta">
      <h3>{titulo}</h3>
      <p>{descripcion}</p>
      <div style={{ marginTop: 'auto', display: 'flex', gap: '0.5rem' }}>
        {/* Los botones son tamaño little, tipo exito y peligro */}
        <Boton tipo="exito" texto="Aceptar" size="normal" onClick={onAceptar} />
        <Boton tipo="peligro" texto="Cancelar" size="normal" onClick={onCancelar} />
      </div>
    </div>
  );
}